module.exports = __webpack_public_path__ + "img/bg-tooltip.5e1fef96.png";